<template>
  <div style="height: 100%; display: inline-block">
    <button
      v-show="!recorderEnabled"
      id="microphone--buton"
      :style="dynamicColors"
      class="footer--mic-icon"
      :title="$t('conversation.voiceRecorder.record')"
      :aria-label="$t('conversation.voiceRecorder.record')"
      @click="handleGetUserPermission()"
    >
      <svg
        x="0px"
        y="0px"
        viewBox="0 0 17 17"
        style="enable-background: new 0 0 17 17"
      >
        <use xlink:href="#widget-chat-icon-audio" />
      </svg>
    </button>

    <Popover
      v-model="showPermissionRequestPopover"
      trigger="manual"
      target="#octadesk--chat--comment"
      :placement="'top'"
      :show-delay="1000"
      :hide-delay="500"
      class="voice-error-popover"
    >
      <template slot="popover">
        <div class="voice-error-popover-body">
          <button
            class="voice-error-popover-close-button"
            @click="showPermissionRequestPopover = false"
          >
            <svg
              viewBox="0 0 1024 1024"
              width="12"
              height="12"
              class="octadesk-close-button-icon"
            >
              <use xlink:href="#octadesk-app-icon-close" />
            </svg>
          </button>

          <h4 class="voice-error-popover-title">
            {{ $t('conversation.voiceRecorder.permission.title') }} 🎤
          </h4>

          <p>
            {{ $t('conversation.voiceRecorder.permission.descriptionLine1') }}

            <br />

            <br />

            {{ $t('conversation.voiceRecorder.permission.descriptionLine2') }}

            <i class="icon icon-msg-error"></i>

            {{ $t('conversation.voiceRecorder.permission.descriptionLine3') }}
          </p>
        </div>
      </template>
    </Popover>

    <Dictaphone
      v-if="recorderEnabled"
      mime-type="audio/ogg"
      rel="dictaphone"
      @error="handleInitializationError($event)"
      @stop="handleRecording($event)"
    >
      <template slot-scope="{ isRecording, startRecording, stopRecording }">
        <div
          ref="startRecord"
          @click="handleStartRecording(startRecording)"
        ></div>

        <div class="octadesk-chat-voice-button btn btn-sem-style is-recording">
          <svg
            class="space-right-lg"
            viewBox="0 0 36 36"
            width="36px"
            height="36px"
            @click="handleStopRecording(stopRecording, 'cancel')"
          >
            <use xlink:href="#icon-audio-cancel" />
          </svg>

          <span
            style="
              background: #ef5753;
              display: inline-block;
              width: 14px;
              height: 14px;
              border-radius: 100%;
            "
          ></span>
          <span class="space-left-xs recording--duration">
            {{ durationFormatted }}
          </span>

          <svg
            class="space-left-lg"
            viewBox="0 0 36 36"
            width="36px"
            height="36px"
            @click="handleStopRecording(stopRecording, 'confirm')"
          >
            <use xlink:href="#icon-audio-check" />
          </svg>
        </div>
      </template>
    </Dictaphone>
  </div>
</template>

<script>
  import services from '@/services'

  import { mapActions, mapGetters } from 'vuex'

  import Dictaphone from './Dictaphone'

  import { Popover } from 'uiv'

  export default {
    components: {
      Dictaphone,
      Popover
    },
    data() {
      return {
        canEnableRecorder: false,
        recorderEnabled: false,
        permissionDenied: false,
        showPermissionRequestPopover: false,
        startedRecording: undefined,
        endedRecording: undefined,
        duration: 0,
        durationInterval: undefined,
        currentAction: ''
      }
    },
    computed: {
      ...mapGetters(['settings']),
      durationFormatted() {
        return new Date(this.duration * 1000).toISOString().substr(14, 5)
      },
      showPermissionDeniedError() {
        return this.permissionDenied && this.showPermissionRequestPopover
      },
      dynamicColors() {
        return {
          '--button-active-bg': `rgba(${this.settings.bgColorRGBA})`
        }
      }
    },
    watch: {
      // eslint-disable-next-line
      showPermissionRequestPopover(enable) {
        this.setOverlayOpen(this.showPermissionRequestPopover)
      },
      permissionDenied(denied) {
        this.setOverlayOpen(denied)
      }
    },
    mounted() {
      let _self = this

      this.recorderEnabled = false

      navigator.permissions
        .query({ name: 'microphone' })
        .then(function (result) {
          if (result.state === 'granted') {
            _self.canEnableRecorder = true
          } else if (result.state === 'prompt') {
            _self.canEnableRecorder = false
          } else if (result.state === 'denied') {
            _self.canEnableRecorder = false
          }
        })
        .catch(function () {
          _self.canEnableRecorder = false
          _self.recorderEnabled = false
        })
    },
    beforeDestroy() {
      if (this.$refs.dictaphone && this.$refs.dictaphone.mediaRecorder) {
        this.$refs.dictaphone.mediaRecorder.stream
          .getTracks() // get all tracks from the MediaStream
          .forEach(track => track.stop())
      }
      this.recorderEnabled = false
    },
    methods: {
      ...mapActions([
        'addAttachment',
        'sendMessage',
        'clearAttachments',
        'setOverlayOpen',
        'cancelQuote'
      ]),
      autoStartRecording(self) {
        const _self = self || this

        _self.canEnableRecorder = true

        _self.recorderEnabled = true

        var clickElem = function () {
          const elem = _self.$refs.startRecord

          elem.click()
        }

        var startRecordInterval = 0

        if (_self.$refs.startRecord) {
          clickElem()
        } else {
          startRecordInterval = window.setInterval(function () {
            if (_self.$refs.startRecord) {
              window.clearInterval(startRecordInterval)

              clickElem()
            }
          }, 200)
        }
      },
      handleInitializationError(err) {
        console.log(err)
      },
      handleGetUserPermission() {
        const _self = this

        if (this.canEnableRecorder) {
          _self.recorderEnabled = true

          this.autoStartRecording()
        } else {
          _self.recorderEnabled = false

          _self.showPermissionRequestPopover =
            !_self.showPermissionRequestPopover

          _self.permissionDenied = false

          navigator.permissions
            .query({ name: 'microphone' })
            .then(function (result) {
              if (result.state === 'granted') {
                _self.canEnableRecorder = true

                _self.setOverlayOpen(false)
              } else if (result.state === 'prompt') {
                _self.showPermissionRequestPopover = true

                navigator.mediaDevices
                  .getUserMedia({ audio: true })
                  .then(function () {
                    _self.canEnableRecorder = true

                    _self.recorderEnabled = true

                    _self.setOverlayOpen(false)

                    _self.showPermissionRequestPopover = false

                    setTimeout(function () {
                      _self.autoStartRecording(_self)
                    }, 500)
                  })
                  .catch(function () {
                    _self.permissionDenied = true

                    _self.setOverlayOpen(false)
                  })
              } else if (result.state === 'denied') {
                _self.permissionDenied = true

                _self.showPermissionRequestPopover = true
              }
            })
            .catch(err => {
              console.error('Error at get microphone permission: ', err)

              _self.canEnableRecorder = false

              _self.recorderEnabled = false
            })
        }
      },
      handleStartRecording(componentStartCallback) {
        this.$emit('startRecording')

        const _self = this

        _self.duration = 0

        window.clearInterval(this.durationInterval)

        this.durationInterval = window.setInterval(function () {
          _self.duration += 1
        }, 1000)

        componentStartCallback()
      },
      handleStopRecording(callback, action) {
        this.currentAction = action

        callback()

        this.$emit('stopRecording')

        window.clearInterval(this.durationInterval)

        this.duration = 0

        if (action === 'confirm') {
          this.cancelQuote()
        }
      },
      handleRecording({ blob }) {
        window.clearInterval(this.durationInterval)

        if (this.currentAction === 'confirm') {
          const _self = this

          let formData = new FormData()

          formData.append(
            'file',
            blob,
            `${this.$t('conversation.voiceRecorder.archiveName')}.ogg`
          )

          services.upload.uploadFile({
            body: formData,
            progress: function () {},
            success: function (res) {
              setTimeout(async () => {
                res.isVoiceRecorder = true
                _self.addAttachment(res)
                await _self.sendMessage()
                _self.clearAttachments()
              }, 0)
            }
          })
        }

        this.recorderEnabled = false

        this.currentAction = undefined
      }
    }
  }
</script>

<style lang="scss" scoped>
  .octadesk-chat-voice-button {
    padding: 0px !important;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    /* margin-top: 6px; */

    svg {
      width: 30px;
      height: 30px;
    }

    span.recording--duration {
      font-size: 18px;
    }

    &.is-recording {
      border-radius: 10px;
      padding: 5px;
      left: 0;
      z-index: 0;
      .icon {
        padding: 2px;
        cursor: pointer;
      }

      .cancel {
        color: #ff6b64;
        font-size: 9px;
      }

      .confirm {
        color: forestgreen;
      }
    }
  }

  .ar-icon {
    fill: rgb(102, 102, 102);
    cursor: pointer;
    transition: 0.2s;
  }
  .ar-icon--no-border {
    border: 0;
    border-radius: 0;
    padding: 0;
  }
  .ar-icon--rec {
    fill: #ff6b64;
    background-color: #f5f5f5;
    border-color: transparent;
  }
  .ar-icon--pulse {
    animation: ripple 0.5s linear infinite;
  }
  @keyframes ripple {
    0% {
      box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.1), 0 0 0 1px rgba(255, 0, 0, 0.1),
        0 0 0 5px rgba(255, 0, 0, 0.1);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.1), 0 0 0 10px rgba(255, 0, 0, 0.1),
        0 0 0 20px rgba(255, 0, 0, 0);
    }
  }
  .ar-icon__xs {
    width: 18px;
    height: 18px;
    line-height: 18px;
  }
  .ar-icon__sm {
    width: 20px;
    height: 18px;
    line-height: 18px;
  }
  .ar-icon__lg {
    width: 45px;
    height: 45px;
    line-height: 45px;
    box-shadow: 0 2px 5px 1px rgba(158, 158, 158, 0.5);
  }

  .footer--mic-icon {
    width: 18px;
    height: 18px;
    background: transparent;
    cursor: pointer;
    border-radius: 100%;
    transition: background-color, 0.6s;
    fill: #aeaeb0;
    margin-left: 0.2rem;
  }

  .footer--mic-icon:hover,
  .footer--mic-icon:focus {
    opacity: 1;
    color: var(--button-active-bg);
  }

  .recording--duration {
    font-family: Roboto;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #484848;
  }

  .voice-error-popover-body {
    max-width: 200px;
    padding: 0.4rem;
    font-size: 12px;
  }

  .voice-error-popover-close-button {
    color: #ffffff;
    position: absolute;
    top: -1.4rem;
    right: 0;
    cursor: pointer;
  }

  .voice-error-popover-title {
    margin-top: 0;
    font-size: 14px;
    margin-bottom: 0.5rem;
    font-weight: 600;
  }

  .popover.top > .arrow:after {
    border-top-color: #ffffff;
  }
</style>
